//有头部和尾部
const router = [
  {
    path: "/home",
    meta: {
      title: "首页",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/home/index"], resolve),
  },
  {
    path: "/auctionCenter",
    meta: {
      title: "交易中心",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/home/version2"], resolve),
  },
  {
    path: "/aboutus",
    meta: {
      title: "关于项目",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/home/aboutus"], resolve),
  },

  {
    path: "/rulesList",
    meta: {
      title: "平台规则",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/home/rulesList"], resolve),
  },

  {
    path: "/specialtyAquaticProducts",
    meta: {
      title: "特色水产品",
      // keepAlive: true
    },
    component: (resolve) =>
      require(["../views/home/specialtyAquaticProducts"], resolve),
  },

  {
    path: "/news",
    meta: {
      title: "新闻列表",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/news/news"], resolve),
  },
  {
    path: "/news/newsDetail",
    meta: {
      title: "新闻详情",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/news/newsDetail"], resolve),
  },
  {
    path: "/special/special",
    meta: {
      title: "专场详情",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/special/special"], resolve),
  },
  {
    path: "/dataAndInfo",
    meta: {
      title: "数据资讯",
      // keepAlive: true
    },
    component: (resolve) =>
      require(["../views/dataAndInfo/dataAndInfo"], resolve),
  },
  {
    path: "/dieselPrice",
    meta: {
      title: "柴油价格",
      // keepAlive: true
    },
    component: (resolve) =>
      require(["../views/dataAndInfo/dieselPrice"], resolve),
  },
  {
    path: "/exchangeRate",
    meta: {
      title: "实时汇率",
      // keepAlive: true
    },
    component: (resolve) =>
      require(["../views/dataAndInfo/exchangeRate"], resolve),
  },
  {
    path: "/cornerPost",
    meta: {
      title: "世界集装箱运转指数",
      // keepAlive: true
    },
    component: (resolve) =>
      require(["../views/dataAndInfo/cornerPost"], resolve),
  },
  {
    path: "/publish",
    meta: {
      title: "发布",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/publish/index"], resolve),
  },
  {
    path: "/lookGoods/index",
    meta: {
      title: "看货记录",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/lookGoods/index"], resolve),
  },
  {
    path: "/lookGoods/detail",
    meta: {
      title: "看货记录详情",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/lookGoods/detail"], resolve),
  },
  {
    path: "/productDetail",
    meta: {
      title: "详情",
      // keepAlive: true
    },
    component: (resolve) =>
      require(["../views/productDetail/productDetail"], resolve),
  },
  {
    path: "/auctionCenter/blueList",
    meta: {
      title: "竞拍中心",
      // keepAlive: true
    },
    component: (resolve) =>
      require(["../views/auctionCenter/blueList"], resolve),
  },
  {
    path: "/auctionCenter/redList",
    meta: {
      title: "竞拍中心-鱼博会红色主题",
      // keepAlive: true
    },
    component: (resolve) =>
      require(["../views/auctionCenter/redList"], resolve),
  },
  {
    path: "/auctionCenter/version2",
    meta: {
      title: "竞拍中心",
      // keepAlive: true
    },
    component: (resolve) =>
      require(["../views/auctionCenter/version2"], resolve),
  },
  {
    path: "/auctionCenter/newerDemo",
    meta: {
      title: "新手演示",
      // keepAlive: true
    },
    component: (resolve) =>
      require(["../views/auctionCenter/newerDemo"], resolve),
  },
  {
    path: "/auctionCenter/detail",
    meta: {
      title: "竞价详情",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/auctionCenter/detail"], resolve),
  },
  {
    path: "/userAuth",
    meta: {
      title: "开通支付账号",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/userAuth/userAuth"], resolve),
  },
  {
    path: "/agreement/agreement",
    meta: {
      title: "协议详情",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/agreement/agreement"], resolve),
  },

  {
    path: "/userCenter",
    meta: {
      title: "个人中心",
    },
    component: (resolve) => require(["../views/userCenter/layout"], resolve),
    children: [
      {
        path: "/userCenter/index",
        meta: {
          title: "个人首页",
        },
        component: (resolve) => require(["../views/userCenter/index"], resolve),
      },
      {
        path: "/userCenter/myPublish",
        meta: {
          title: "我发布的",
        },
        component: (resolve) =>
          require(["../views/userCenter/myPublish"], resolve),
      },
      {
        path: "/userCenter/order/orderList",
        meta: {
          title: "我的订单",
        },
        component: (resolve) =>
          require(["../views/userCenter/order/orderList"], resolve),
      },
      {
        path: "/userCenter/order/orderDetail",
        meta: {
          title: "订单详情",
        },
        component: (resolve) =>
          require(["../views/userCenter/order/orderDetail"], resolve),
      },
      {
        path: "/userCenter/myAccount/index",
        meta: {
          title: "我的账户",
        },
        component: (resolve) =>
          require(["../views/userCenter/myAccount/index"], resolve),
      },
      {
        path: "/userCenter/myAccount/dealDetails",
        meta: {
          title: "账户明细",
        },
        component: (resolve) =>
          require(["../views/userCenter/myAccount/dealDetails"], resolve),
      },
      {
        path: "/userCenter/myAccount/withdraw",
        meta: {
          title: "提现",
        },
        component: (resolve) =>
          require(["../views/userCenter/myAccount/withdraw"], resolve),
      },
      {
        path: "/userCenter/accountAssociation",
        meta: {
          title: "账号关联",
        },
        component: (resolve) =>
          require(["../views/userCenter/accountAssociation/index"], resolve),
      },
      {
        path: "/userCenter/applyFinancialDetails",
        meta: {
          title: "金融预审信息",
        },
        component: (resolve) =>
          require(["../views/userCenter/applyFinancialDetails/index"], resolve),
      },
      {
        path: "/userCenter/myRegisterBidding",
        meta: {
          title: "我报名的竞价",
        },
        component: (resolve) =>
          require(["../views/userCenter/myRegisterBidding"], resolve),
      },
      {
        path: "/userCenter/myLikeArticle",
        meta: {
          title: "我点赞的文章",
        },
        component: (resolve) =>
          require(["../views/userCenter/myLikeArticle"], resolve),
      },
      {
        path: "/userCenter/loansList",
        meta: {
          title: "还款提货",
        },
        component: (resolve) =>
          require(["../views/userCenter/loansList"], resolve),
      },
      {
        path: "/userCenter/pickGoodsDetails",
        meta: {
          title: "货源详情",
        },
        component: (resolve) =>
          require(["../views/userCenter/pickGoodsDetails"], resolve),
      },
    ],
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js